import { render, staticRenderFns } from "./NoticePopup.vue?vue&type=template&id=6965d962&scoped=true"
import script from "./NoticePopup.vue?vue&type=script&lang=js"
export * from "./NoticePopup.vue?vue&type=script&lang=js"
import style0 from "./NoticePopup.vue?vue&type=style&index=0&id=6965d962&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6965d962",
  null
  
)

export default component.exports